'use client';

import React, { useRef, useState } from 'react';
import { useRouter } from 'next/navigation';

import { useCategoryMegaMenu } from '@/providers/CategoryMegaMenuProvider';

import { Button, Typography } from 'lighthouse';

import { CategoryMegaMenu } from '@/widgets/Navbar/DesktopMenu/_components/CategoryMegaMenu';
import { DesktopMenuProps } from '@/widgets/Navbar/DesktopMenu/models';

import { desktopMenuItems } from '@/constants/menuItems';

import { Element4 } from 'iconsax-react';

const MENU_CLOSE_DELAY_MS = 150;

export const DesktopMenu = ({ isDark }: DesktopMenuProps) => {
    const [isCategoryMenuOpen, setIsCategoryMenuOpen] = useState(false);
    const { categoryMegaMenuItems } = useCategoryMegaMenu();
    const closeTimerRef = useRef<number | null>(null);
    const router = useRouter();

    const clearCloseTimer = () => {
        if (closeTimerRef.current) {
            window.clearTimeout(closeTimerRef.current);
            closeTimerRef.current = null;
        }
    };

    const openCategoryMenu = () => {
        clearCloseTimer();
        setIsCategoryMenuOpen(true);
    };

    const scheduleCloseCategoryMenu = () => {
        clearCloseTimer();
        closeTimerRef.current = window.setTimeout(() => {
            setIsCategoryMenuOpen(false);
        }, MENU_CLOSE_DELAY_MS);
    };

    const toggleCategoryMenu = () => {
        clearCloseTimer();
        setIsCategoryMenuOpen((isOpen) => !isOpen);
    };

    return (
        <nav className={`z-50 mt-1 hidden shrink-0 items-center md:flex ${isDark ? 'bg-neutral-900' : 'bg-white'}`}>
            <ul className='my-0 flex items-center md:gap-x-1 md:pr-2 lg:gap-x-4 lg:pr-10'>
                <li className='list-none'>
                    <div className='relative' onMouseEnter={openCategoryMenu} onMouseLeave={scheduleCloseCategoryMenu}>
                        <Button
                            variant='text'
                            onClick={toggleCategoryMenu}
                            aria-expanded={isCategoryMenuOpen}
                            className={`cursor-pointer bg-transparent ${isDark ? 'text-neutral-300' : 'text-neutral-600'}`}>
                            <Typography
                                variant='button'
                                className={`flex items-center justify-center gap-x-1 whitespace-nowrap md:text-xs lg:text-sm
                                    ${isCategoryMenuOpen ? 'text-primary/70' : 'hover:text-primary/70'}`}>
                                <Element4 size={14} color='currentColor' variant={isCategoryMenuOpen ? 'Bulk' : 'Outline'} />
                                خدمات
                            </Typography>
                        </Button>

                        <CategoryMegaMenu
                            open={isCategoryMenuOpen}
                            categories={categoryMegaMenuItems}
                            isDark={isDark}
                            onNavigate={() => setIsCategoryMenuOpen(false)}
                        />
                    </div>
                </li>

                {desktopMenuItems.map((menu) => (
                    <li key={menu.id} className='list-none'>
                        <Button
                            variant='text'
                            onClick={() => router.push(menu.link || '#')}
                            className={`cursor-pointer bg-transparent ${isDark ? 'text-neutral-300' : 'text-neutral-600'}`}>
                            <Typography
                                variant='button'
                                className='flex items-center justify-center whitespace-nowrap hover:text-primary/70 md:text-xs lg:text-sm'>
                                {menu.title}
                            </Typography>
                        </Button>
                    </li>
                ))}
            </ul>
        </nav>
    );
};
